import ButtonGroupYesNoWithLabel from "@/components/ui/molecules/ButtonGroupYesNoWithLabel/ButtonGroupYesNoWithLabel";
import AdminSettingsCommunicateEmailSignature from "@/components/ui/organisms/Admin/Settings/Communicate/AdminSettingsCommunicateEmailSignature";
import AdminSettingsCommunicateKeepMails from "@/components/ui/organisms/Admin/Settings/Communicate/AdminSettingsCommunicateKeepMails";
import { useSelectedLinkContext } from "@/contexts";
import { SAVE_DEVICE_SETTINGS } from "@/graphql/admin/settings/SettingsMutations";
import { GET_DEVICE_COMMUNICATE_SETTINGS } from "@/graphql/admin/settings/SettingsQueries";
import { CommunicateSettings, QueryGetCommunicateSettingsResponse } from "@/types/settings.types";
import { FetchResult, useMutation, useQuery } from "@apollo/client";

const AdminSettingsCommunicatePage = (): JSX.Element => {

  const { selectedLink } = useSelectedLinkContext();
  const { data, refetch } = useQuery<QueryGetCommunicateSettingsResponse>(
    GET_DEVICE_COMMUNICATE_SETTINGS,
    {
      variables: {
        getDeviceSettingsInput: {
          channel: selectedLink?.channelKey,
        }
      },
    },
  );

  const [saveCommunicationSettingsGQL] = useMutation<any>(SAVE_DEVICE_SETTINGS);
  const saveCommunicationSettings = (settings: CommunicateSettings): Promise<FetchResult<any>> => {
    return saveCommunicationSettingsGQL({
      variables: {
        saveDeviceSettingsInput: {
          channel: selectedLink.channelKey,
          settings: settings,
        },
      },
    });
  }

  const updateCommunicationSettings = (settings: CommunicateSettings): void => {
    saveCommunicationSettings(settings)
      .then(() => {
        void refetch();
      }).catch((error) => {
        console.log(error);
      });
  }

  return data?.getDeviceSettings?.settings && (
    <div className="flex flex-col gap-2w bg-neutral-100">
      <h2 className="text-header3 text-white p-2w bg-admin-darkblue-300">Communiquer</h2>
      <div className="flex flex-col gap-4w p-2w m-2w rounded-2xl bg-white">
        <ButtonGroupYesNoWithLabel 
          label="Les pièces jointes reçues (hors messages filtrés) sont ajoutées dans un album “Pièces jointes” dans la rubrique “Mon classeur”"
          value={data?.getDeviceSettings?.settings?.mailUnfilteredAttachmentAddedToDocuments}
          onChange={(value) => updateCommunicationSettings({mailUnfilteredAttachmentAddedToDocuments: value})}
        />
        <ButtonGroupYesNoWithLabel 
          label="Les pièces jointes reçues des messages filtrés sont ajoutées dans un album “Pièces jointes” dans la rubrique “Mon classeur”"
          value={data?.getDeviceSettings?.settings?.mailFilteredAttachmentAddedToDocuments}
          onChange={(value) => updateCommunicationSettings({mailFilteredAttachmentAddedToDocuments: value})} />
        <AdminSettingsCommunicateEmailSignature 
          value={data?.getDeviceSettings?.settings?.mailDisplaySignature}
          onChange={(value) => updateCommunicationSettings({mailDisplaySignature: value})}
          signatureValue={data?.getDeviceSettings?.settings?.mailSignature}
          onSignatureChange={(value) => updateCommunicationSettings({mailSignature: value})} />
        <ButtonGroupYesNoWithLabel 
          label="Les messages non-lus sont regroupés en haut de la liste"
          value={data?.getDeviceSettings?.settings?.mailUnreadFirst} 
          onChange={(value) => updateCommunicationSettings({mailUnreadFirst: value})} />
        <ButtonGroupYesNoWithLabel 
          label="Lire les messages en plein écran"
          value={data?.getDeviceSettings?.settings?.mailReadFullScreen} 
          onChange={(value) => updateCommunicationSettings({mailReadFullScreen: value})} />
        <AdminSettingsCommunicateKeepMails 
          label="Conserver les brouillons"
          value={data?.getDeviceSettings?.settings?.mailDraftRemovalDelayInDays} 
          onChange={(value) => updateCommunicationSettings({mailDraftRemovalDelayInDays: value})} />
        <AdminSettingsCommunicateKeepMails 
          label="Conserver les messages filtrés"
          value={data?.getDeviceSettings?.settings?.mailSpamRemovalDelayInDays} 
          onChange={(value) => updateCommunicationSettings({mailSpamRemovalDelayInDays: value})} />
      </div>
    </div>
  );
}

export default AdminSettingsCommunicatePage;